export const enCommunityForgotEmail = {
  CA60emailToChange: 'Email address to change',
  CA60heading1: 'Please enter the following items to reset your email address. If you forget your secret question,',
  CA60heading2: 'From the inquiry form',
  CA60heading3: 'Please contact me.',
}
